export default __webpack_public_path__ + "static/media/wrong.deef8665.jpg";